/**
 * Created by wwei on 2017-06-29.
 */
import "babel-polyfill";
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import {
  AsyncRegisterLogin,
  AsyncCreateAccountBasicInfo,
  AsyncCreateAccountActivation
} from "./CodeSplitting";
import Switching from "./common/components/Switching";
import Dispatch from "./Dispatch.js";
import DomainVerification from "./tenantportal/domainMgmt/DomainVerification";
import { URL } from "./common/Constants";
import NoRoleRedirect from "./NoRoleRedirect";

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path={URL.REGISTER} component={AsyncRegisterLogin} />
          <Route path={URL.SELF_REG} component={AsyncCreateAccountBasicInfo} />
          <Route
            path={URL.SELF_REG_2}
            component={AsyncCreateAccountActivation}
          />
          <Route path={URL.NO_ROLE} component={NoRoleRedirect} />
          <Route path={URL.VERIFY_DOMAIN} component={DomainVerification} />
          <Route path={URL.SWITCH} component={Switching} />
          <Route path={URL.DISPATCH} component={Dispatch} />
          <Route component={Dispatch} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js